import i18n from "@/plugins/i18n";
import numeral from 'numeral';

export default {
  getImageSrc(fileName) {
    var image = require('@/assets/images/DefaultImage.png');
    try {
      var image = require('@/assets/images/' + fileName);
    } catch (error) {
    }
    return image;
  },
  monthNames() {
    return [
      i18n.global.t("Jan"),
      i18n.global.t("Feb"),
      i18n.global.t("Mar"),
      i18n.global.t("Apr"),
      i18n.global.t("_Abbreviation.May"),
      i18n.global.t("Jun"),
      i18n.global.t("Jul"),
      i18n.global.t("Aug"),
      i18n.global.t("Sep"),
      i18n.global.t("Oct"),
      i18n.global.t("Nov"),
      i18n.global.t("Dec"),
      i18n.global.t("January"),
      i18n.global.t("February"),
      i18n.global.t("March"),
      i18n.global.t("April"),
      i18n.global.t("May"),
      i18n.global.t("June"),
      i18n.global.t("July"),
      i18n.global.t("August"),
      i18n.global.t("September"),
      i18n.global.t("October"),
      i18n.global.t("November"),
      i18n.global.t("December")
    ].slice(0, 12);
  },
  daysOfWeek() {
    return [
      i18n.global.t("Sun"),
      i18n.global.t("Mon"),
      i18n.global.t("Tue"),
      i18n.global.t("Wed"),
      i18n.global.t("Thu"),
      i18n.global.t("Fri"),
      i18n.global.t("Sat"),
      i18n.global.t("Sunday"),
      i18n.global.t("Monday"),
      i18n.global.t("Tuesday"),
      i18n.global.t("Wednesday"),
      i18n.global.t("Thursday"),
      i18n.global.t("Friday"),
      i18n.global.t("Saturday")
    ].slice(0, 7).map((function(t) {
      return t.substring(0, 2)
    }));
  },
  ranges(rengesFilter=[]) {
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    let todayEnd = new Date()
    // todayEnd.setHours(11, 59, 59, 999);
    todayEnd.setHours(23, 59, 59, 999);

    let yesterdayStart = new Date()
    yesterdayStart.setDate(today.getDate() - 1)
    yesterdayStart.setHours(0, 0, 0, 0);

    let yesterdayEnd = new Date()
    yesterdayEnd.setDate(today.getDate() - 1)
    yesterdayEnd.setHours(23, 59, 59, 999);

    let last30DaysStart = new Date()
    last30DaysStart.setDate(today.getDate() - 29)
    last30DaysStart.setHours(0, 0, 0, 0);

    let last30DaysEnd = new Date()
    last30DaysEnd.setDate(today.getDate())
    last30DaysEnd.setHours(23, 59, 59, 999);

    let last7DaysStart = new Date()
    last7DaysStart.setDate(today.getDate() - 6)
    last7DaysStart.setHours(0, 0, 0, 0);

    let last7DaysEnd = new Date()
    last7DaysEnd.setDate(today.getDate())
    last7DaysEnd.setHours(23, 59, 59, 999);

    let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    // let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999);
    let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 23, 59, 59, 999);

    let defaultRanges = {};
    if(rengesFilter.length > 0){
      rengesFilter.forEach(key => {
        switch (key) {
          case 'Today':
            let toDay = { '_Dashboard.Today': [today, todayEnd] };
            Object.assign(defaultRanges, toDay);
            break;
          case 'Yesterday':
            let yesterday = { '_Dashboard.Yesterday': [yesterdayStart, yesterdayEnd] };
            Object.assign(defaultRanges, yesterday);
            break;
          case 'Last 7 Days':
            let last7Days = { '_Dashboard.Last 7 Days': [last7DaysStart, last7DaysEnd] };
            Object.assign(defaultRanges, last7Days);
            break;
          case 'Last 30 Days':
            let last30Days = { '_Dashboard.Last 30 Days': [last30DaysStart, last30DaysEnd] };
            Object.assign(defaultRanges, last30Days);
            break;
          case 'This Month':
            let thisMonth = { '_Dashboard.This Month': [thisMonthStart, thisMonthEnd] };
            Object.assign(defaultRanges, thisMonth);
            break;
          case 'Last Month':
            let lastMonth = { '_Dashboard.Last Month': [
              new Date(today.getFullYear(), today.getMonth() - 1, 1),
              // new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)
              new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 999)
            ], };
            Object.assign(defaultRanges, lastMonth);
            break;
          case 'This Year':
            let thisYear = { '_Dashboard.This Year': [
              new Date(today.getFullYear(), 0, 1),
              // new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
              new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
            ], };
            Object.assign(defaultRanges, thisYear);
            break;
          case 'Year':
            let year = { '_Dashboard.Year': [
              new Date(today.getFullYear() -5, 0, 1),
              // new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
              new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
            ], };
            Object.assign(defaultRanges, year);
            break;
          default:
            break;
        }
      });
    }else{
      defaultRanges = {
        'Today': [today, todayEnd],
        'Yesterday': [yesterdayStart, yesterdayEnd],
        'This month': [thisMonthStart, thisMonthEnd],
        'This year': [
          new Date(today.getFullYear(), 0, 1),
          // new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
          new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
        ],
        'Last month': [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          // new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)
          new Date(today.getFullYear(), today.getMonth(), 0, 23, 59, 59, 999)
        ],
      }
    }

    let _ranges = [];
    for (const [key, value] of Object.entries(defaultRanges)) {
      _ranges[
        i18n.global.t(key)] = value;
    }
    return Object.assign({}, _ranges);
  },
  singleRanges(date = null) {
    try{
      let today = new Date();
      let todayEnd = new Date();
      if(date != null){
        today = new Date(date.startDate);
        if(date.endDate == null){
          todayEnd = new Date(date.startDate);
        }else{
          todayEnd = new Date(date.endDate);
        }
      }

      today = new Date(today);
      todayEnd = new Date(todayEnd);
      let minutes5BeforeStart = new Date(today)
      let minutes5BeforeEnd = new Date(todayEnd)
      let minutes10BeforeStart = new Date(today)
      let minutes10BeforeEnd = new Date(todayEnd)
      let minutes15BeforeStart = new Date(today)
      let minutes15BeforeEnd = new Date(todayEnd)
      let minutes30BeforeStart = new Date(today)
      let minutes30BeforeEnd = new Date(todayEnd)
      let hours1BeforeStart = new Date(today)
      let hours1BeforeEnd = new Date(todayEnd)
      let hours2BeforeStart = new Date(today)
      let hours2BeforeEnd = new Date(todayEnd)
      let yesterdayStart = new Date(today)
      let yesterdayEnd = new Date(todayEnd)
      let twoDaysAgoStart = new Date(today)
      let twoDaysAgoEnd = new Date(todayEnd)

      today.setHours(today.getHours());
      todayEnd.setHours(todayEnd.getHours());

      minutes5BeforeStart.setHours(today.getHours());
      minutes5BeforeStart.setMinutes(today.getMinutes() - 5);
      minutes5BeforeStart.setSeconds(today.getSeconds());

      minutes5BeforeEnd.setHours(todayEnd.getHours());
      minutes5BeforeEnd.setMinutes(todayEnd.getMinutes() - 5);
      minutes5BeforeEnd.setSeconds(todayEnd.getSeconds());

      minutes10BeforeStart.setHours(today.getHours());
      minutes10BeforeStart.setMinutes(today.getMinutes() - 10);
      minutes10BeforeStart.setSeconds(today.getSeconds());
      minutes10BeforeStart.setMilliseconds(today.getMilliseconds());

      minutes10BeforeEnd.setHours(todayEnd.getHours());
      minutes10BeforeEnd.setMinutes(todayEnd.getMinutes() - 10);
      minutes10BeforeEnd.setSeconds(todayEnd.getSeconds());
      minutes10BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

      minutes15BeforeStart.setHours(today.getHours());
      minutes15BeforeStart.setMinutes(today.getMinutes() - 15);
      minutes15BeforeStart.setSeconds(today.getSeconds());
      minutes15BeforeStart.setMilliseconds(today.getMilliseconds());

      minutes15BeforeEnd.setHours(todayEnd.getHours());
      minutes15BeforeEnd.setMinutes(todayEnd.getMinutes() - 15);
      minutes15BeforeEnd.setSeconds(todayEnd.getSeconds());
      minutes15BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

      minutes30BeforeStart.setHours(today.getHours());
      minutes30BeforeStart.setMinutes(today.getMinutes() - 30);
      minutes30BeforeStart.setSeconds(today.getSeconds());
      minutes30BeforeStart.setMilliseconds(today.getMilliseconds());

      minutes30BeforeEnd.setHours(todayEnd.getHours());
      minutes30BeforeEnd.setMinutes(todayEnd.getMinutes() - 30);
      minutes30BeforeEnd.setSeconds(todayEnd.getSeconds());
      minutes30BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

      hours1BeforeStart.setHours(today.getHours() - 1);
      hours1BeforeStart.setMinutes(today.getMinutes());
      hours1BeforeStart.setSeconds(today.getSeconds());
      hours1BeforeStart.setMilliseconds(today.getMilliseconds());

      hours1BeforeEnd.setHours(todayEnd.getHours() - 1);
      hours1BeforeEnd.setMinutes(todayEnd.getMinutes());
      hours1BeforeEnd.setSeconds(todayEnd.getSeconds());
      hours1BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

      hours2BeforeStart.setHours(today.getHours() - 2);
      hours2BeforeStart.setMinutes(today.getMinutes());
      hours2BeforeStart.setSeconds(today.getSeconds());
      hours2BeforeStart.setMilliseconds(today.getMilliseconds());

      hours2BeforeEnd.setHours(todayEnd.getHours() - 2);
      hours2BeforeEnd.setMinutes(todayEnd.getMinutes());
      hours2BeforeEnd.setSeconds(todayEnd.getSeconds());
      hours2BeforeEnd.setMilliseconds(todayEnd.getMilliseconds());

      yesterdayStart.setDate(today.getDate() - 1)
      yesterdayStart.setHours(today.getHours());

      yesterdayEnd.setDate(today.getDate() - 1)
      yesterdayEnd.setHours(today.getHours());

      twoDaysAgoStart.setDate(today.getDate() - 2)
      twoDaysAgoStart.setHours(today.getHours());

      twoDaysAgoEnd.setDate(today.getDate() - 2)
      twoDaysAgoEnd.setHours(today.getHours());

      const defaultRanges = {
        'At time of event':   [today, todayEnd],
        '5 minutes before':   [minutes5BeforeStart, minutes5BeforeEnd],
        '10 minutes before':  [minutes10BeforeStart, minutes10BeforeStart],
        '15 minutes before':  [minutes15BeforeStart, minutes15BeforeStart],
        '30 minutes before':  [minutes30BeforeStart, minutes30BeforeStart],
        '1 hour before':      [hours1BeforeStart, hours1BeforeStart],
        '2 hour before':      [hours2BeforeStart, hours2BeforeEnd],
        '1 day before':       [yesterdayStart, yesterdayEnd],
        '2 day before':       [twoDaysAgoStart, twoDaysAgoEnd],
      }

      let _ranges = [];
      for (const [key, value] of Object.entries(defaultRanges)) {
        _ranges[i18n.t(key)] = value;
      }
      return Object.assign({}, _ranges);

    } catch (error) {
    }
  },
  backgroundColorInventoryType(type) {
    let color = 'background-color: #03543F;';
    switch (type) {
      case 'Ingredient':
        color = 'background-color: #03543F;';
        break;
      case 'Trading Good':
        color = 'background-color: #1E429F;';
        break;
      case 'Packaging':
        color = 'background-color: #92400E;';
        break;
      case 'Supply':
        color = 'background-color: #374151;';
        break;
    }
    return color;
  },
  backgroundCSSTableSatus(type) {
    let color = 'bg-success';
    switch (type) {
      case 'Available':
        color = 'bg-success';
        break;
      case 'Qr Ready':
        color = 'bg-primary';
        break;
      case 'Occupied':
        color = 'bg-danger';
        break;
      case 'Reserved':
        color = 'bg-warning text-dark';
        break;
      case 'Maintenance':
        color = 'bg-secondary';
        break;
    }
    return color;
  },
  CSSStatusTableItem(type) {
    let color = 'status-available';
    switch (type) {
      case 'Available':
        color = 'status-available';
        break;
      case 'Qr Ready':
        color = 'status-waiting';
        break;
      case 'Occupied':
        color = 'status-occupied';
        break;
      case 'Reserved':
        color = 'status-reserved';
        break;
    }
    return color;

  },
  getImageUrl(path) {
    if (path && typeof path === 'string' && path.trim() !== '') {
      return path;
    }
    return require('@/assets/images/DefaultImage.png');
  },
  /**
   * รูปที่ใช้บนการ์ด/แถวในหน้าเมนู (POS + QR ลูกค้า)
   *
   * thumbnail รุ่นใหม่กว้าง 400px พอดีกับการ์ดที่กว้างจริง ~200px บนจอ 2x
   * และเบากว่ารูปเต็ม 800px ราว 6 เท่า ร้านที่มีเมนูหลักร้อยจานจึงไม่ต้องลากรูปเต็ม
   * ลงมาทุกใบตั้งแต่เปิดหน้า ส่วน image_url เก็บไว้ใช้ตอนกดดูรูปขยายเหมือนเดิม
   *
   * ⚠️ thumbnail รุ่นเก่ากว้างแค่ 100px ซึ่งเบลอเกินกว่าจะเอามาขึ้นการ์ดได้
   *    แยกสองรุ่นด้วยนามสกุล: .webp = ผ่าน Portals\Image รุ่นใหม่ หรือถูก media:to-webp
   *    แปลงมาแล้ว แปลว่ากว้าง 400px แน่นอน · นามสกุลอื่น = ของเก่า ใช้รูปเต็มไปก่อน
   *    ร้านไหนแปลงรูปเก่าเสร็จ การ์ดจะย้ายมาใช้ thumbnail เองโดยไม่ต้องปล่อย FE ใหม่
   */
  menuImageUrl(product) {
    if (!product) return '';
    const thumbnail = product.thumbnail_url;
    if (thumbnail && thumbnail.toLowerCase().endsWith('.webp')) return thumbnail;
    return product.image_url || thumbnail || '';
  },
  onImageError(event) {
    if (event.target.src !== require('@/assets/images/DefaultImage.png')) {
      event.target.src = require('@/assets/images/DefaultImage.png');
      event.target.onerror = null;
    }
  },
  onLogoError(event) {
    if (event.target.src !== require('@/assets/images/default_logo.png')) {
      event.target.src = require('@/assets/images/default_logo.png');
      event.target.onerror = null;
    }
  },
  formatThaiCurrency(value) {
    return new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
      minimumFractionDigits: 2, // ปรับเป็น 2 ถ้าต้องการทศนิยม .00
    }).format(value);
    const num = Number(value);
    // ถ้าไม่ใช่ตัวเลข ให้คืนค่าเดิมหรือค่าว่างกลับไป
    if (isNaN(num)) return '฿0.00';
    // ใช้ Math.abs() แปลงค่าให้เป็นบวกเสมอ เพื่อเอาเครื่องหมาย - ออกก่อน
    // แล้วใช้ numeral จัดฟอร์แมตใส่ลูกน้ำ (และทศนิยม 2 ตำแหน่ง)
    const formattedNumber = numeral(Math.abs(num)).format("0,0.00"); // ถ้าไม่เอาทศนิยมเปลี่ยนเป็น "0,0"
    // เช็คค่าดั้งเดิม ถ้าติดลบให้เติม -฿ ถ้าเป็นบวกให้เติม ฿
    return num < 0 ? `-฿${formattedNumber}` : `฿${formattedNumber}`;
  },
  getTimeDiff(dateTime) {
    const start = new Date();
    const end = new Date(dateTime);

    const diffInMs = Math.abs(end - start);

    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));


    if (diffInMinutes < 60) {
      return `${diffInMinutes}`+ i18n.global.t('m');
    }

    const hours = Math.floor(diffInMinutes / 60);
    const mins = diffInMinutes % 60;

    return mins > 0 ? `${hours}${i18n.global.t('h')} ${mins}${i18n.global.t('m')}` : `${hours}${i18n.global.t('h')}`;
  }
}
